import { render, staticRenderFns } from "./Describer.vue?vue&type=template&id=05108aca&scoped=true&"
import script from "./Describer.vue?vue&type=script&lang=js&"
export * from "./Describer.vue?vue&type=script&lang=js&"
import style0 from "./Describer.vue?vue&type=style&index=0&id=05108aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05108aca",
  null
  
)

export default component.exports